var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['aui-avatar', 'aui-avatar-' + _vm.size, _vm.squared ? 'aui-avatar-squared' : '']},[_c('span',{staticClass:"aui-avatar-inner"},[_c('img',{attrs:{"src":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }